import React from 'react';
import { RiDeleteBin5Fill, RiEyeFill, RiPencilFill } from 'react-icons/ri';
import { Button } from 'reactstrap';

const ActionsFormatter = (props) => {
  const {
    handleDelete = () => {},
    handleView = () => {},
    handleEdit = () => {},
    isDelete = true,
    isView = true,
    isEdit = true,
  } = props;

  return (
    <div className="table-action text-end text-nowrap">
      {isView ? (
        <Button
          outline
          color="link"
          className="text-dcoration-none border-0 text-primary"
          onClick={handleView}
        >
          <RiEyeFill size={16} />
        </Button>
      ) : (
        ' '
      )}
      {isEdit ? (
        <Button
          outline
          color="link"
          className="text-dcoration-none border-0 text-primary"
          onClick={handleEdit}
        >
          <RiPencilFill size={16} />
        </Button>
      ) : (
        ' '
      )}
      {isDelete ? (
        <Button
          outline
          color="link"
          className="text-dcoration-none border-0 text-primary"
          onClick={handleDelete}
        >
          <RiDeleteBin5Fill size={16} />
        </Button>
      ) : (
        ''
      )}
    </div>
  );
};

export default ActionsFormatter;
